<template>
  <div class="configuration-home px-sm-4 px-lg-0">
    <b-container fluid="lg">
      <b-row class="mt-5">
        <b-col>
          <div class="main-title">
            <span class="primary-dark-color far fa-cog mr-3" />
            <span
              v-testing="'header'"
              class="primary-dark-color font-weight--medium"
            >{{ $t('configuration.layout.configurationTitle') }}</span>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col>
          <div>
            <b-tabs
              v-model="tabIndex"
              class="vt-tabs"
              @input="updateTabSelection()"
            >
              <b-tab v-if="hasAnyGlobalConfigurationOperation">
                <template #title>
                  <span v-testing="'general-configuration-tab'">{{ $t('configuration.layout.generalConfiguration') }}</span>
                </template>
                <div class="mt-4 scroll-area">
                  <b-row>
                    <b-col
                      v-if="canConfigureGlobalRequesterStructure"
                      sm="4"
                      md="4"
                      lg
                    >
                      <div
                        v-testing="'centers-and-services'"
                        class="conf-card text-center d-flex flex-column py-3 mb-4"
                        @click="goToConfiguration('ConfigurationCentersAndServices')"
                      >
                        <div class="icon w-100 d-flex justify-content-center">
                          <health-center />
                        </div>
                        <span class="mt-2 secondary-color">{{ $t('configuration.elementTitle.centersAndServices') }}</span>
                        <small>{{ $t('configuration.elementSubtitle.centersAndServicesSubtitle') }}</small>
                      </div>
                    </b-col>
                    <b-col
                      v-if="canConfigureGlobalDemography"
                      sm="4"
                      md="4"
                      lg
                    >
                      <div
                        v-testing="'demography'"
                        class="conf-card text-center d-flex flex-column py-3 mb-4"
                        @click="goToConfiguration('ConfigurationDemography')"
                      >
                        <div class="icon w-100 d-flex justify-content-center">
                          <demography />
                        </div>
                        <span class="mt-2 secondary-color">{{ $t('configuration.elementTitle.demography') }}</span>
                        <small>{{ $t('configuration.elementSubtitle.demographySubtitle') }}</small>
                      </div>
                    </b-col>
                    <b-col
                      v-if="canConfigureGlobalPersons"
                      sm="4"
                      md="4"
                      lg
                    >
                      <div
                        v-testing="'users'"
                        class="conf-card text-center d-flex flex-column py-3 mb-4"
                        @click="goToConfiguration('ConfigurationUsers')"
                      >
                        <div class="icon w-100 d-flex justify-content-center">
                          <users />
                        </div>
                        <span class="mt-2 secondary-color">{{ $t('configuration.elementTitle.peopleManagement') }}</span>
                        <small>{{ $t('configuration.elementSubtitle.peopleManagementSubtitle') }}</small>
                      </div>
                    </b-col>
                    <b-col
                      v-if="canConfigureGlobalCases"
                      sm="4"
                      md="4"
                      lg
                    >
                      <div
                        v-testing="'cases'"
                        class="conf-card text-center d-flex flex-column py-3 mb-4"
                        @click="goToConfiguration('ConfigurationCases')"
                      >
                        <div class="icon w-100 d-flex justify-content-center">
                          <cases />
                        </div>
                        <span class="mt-2 secondary-color">{{ $t('configuration.elementTitle.cases') }}</span>
                        <small>{{ $t('configuration.elementSubtitle.casesSubtitle') }}</small>
                      </div>
                    </b-col>
                    <b-col
                      v-if="canConfigureGlobalSamples"
                      sm="4"
                      md="4"
                      lg
                    >
                      <div
                        v-testing="'samples'"
                        class="conf-card text-center d-flex flex-column py-3 mb-4"
                        @click="goToConfiguration('ConfigurationSamples')"
                      >
                        <div class="icon w-100 d-flex justify-content-center">
                          <samples />
                        </div>
                        <span class="mt-2 secondary-color">{{ $t('configuration.elementTitle.samples') }}</span>
                        <small>{{ $t('configuration.elementSubtitle.samplesSubtitle') }}</small>
                      </div>
                    </b-col>
                    <div class="d-none d-lg-block d-xl-block w-100" />
                    <!-- Oculto por el momento con "d-none" -->
                    <b-col
                      sm="4"
                      md="4"
                      lg
                      class="d-none"
                    >
                      <div
                        v-testing="'elements'"
                        class="conf-card text-center d-flex flex-column py-3 mb-4"
                        @click="goToConfiguration('ConfigurationElements')"
                      >
                        <div class="icon w-100 d-flex justify-content-center">
                          <portions-subportions />
                        </div>
                        <span class="mt-2 secondary-color">{{ $t('configuration.elementTitle.elements') }}</span>
                        <small>{{ $t('configuration.elementSubtitle.elementsSubtitle') }}</small>
                      </div>
                    </b-col>
                    <b-col
                      v-if="canConfigureGlobalAssays"
                      sm="4"
                      md="4"
                      lg
                    >
                      <div
                        v-testing="'assays'"
                        class="conf-card text-center d-flex flex-column py-3 mb-4"
                        @click="goToConfiguration('ConfigurationAssays')"
                      >
                        <div class="icon w-100 d-flex justify-content-center">
                          <assays />
                        </div>
                        <span class="mt-2 secondary-color">{{ $t('configuration.elementTitle.assays') }}</span>
                        <small>{{ $t('configuration.elementSubtitle.assaysSubtitle') }}</small>
                      </div>
                    </b-col>
                    <b-col
                      v-if="canConfigureGlobalNotifications"
                      sm="4"
                      md="4"
                      lg
                    >
                      <div
                        v-testing="'notifications-global'"
                        class="conf-card text-center d-flex flex-column py-3 mb-4"
                        @click="goToConfiguration('ConfigurationGlobalNotifications')"
                      >
                        <div class="icon w-100 d-flex justify-content-center">
                          <notifications />
                        </div>
                        <span class="mt-2 secondary-color">{{ $t('configuration.elementTitle.notificationsAlarms') }}</span>
                        <small>{{ $t('configuration.elementSubtitle.notificationsSubtitle') }}</small>
                      </div>
                    </b-col>
                    <b-col
                      v-if="canConfigureGlobalIncidents"
                      sm="4"
                      md="4"
                      lg
                      @click="goToConfiguration('ConfigurationIncidents')"
                    >
                      <div
                        v-testing="'incidents'"
                        class="conf-card text-center d-flex flex-column py-3 mb-4"
                      >
                        <div class="icon w-100 d-flex justify-content-center">
                          <incidents />
                        </div>
                        <span class="mt-2 secondary-color">{{ $t('configuration.elementTitle.incidents') }}</span>
                        <small>{{ $t('configuration.elementSubtitle.incidentsSubtitle') }}</small>
                      </div>
                    </b-col>
                    <b-col
                      v-if="canConfigureGlobalParameters"
                      sm="4"
                      md="4"
                      lg
                    >
                      <div
                        v-testing="'global-parameters'"
                        class="conf-card text-center d-flex flex-column py-3 mb-4"
                        @click="goToConfiguration('ConfigurationParametersGlobal')"
                      >
                        <div class="icon w-100 d-flex justify-content-center">
                          <local-parameters />
                        </div>
                        <span class="mt-2 secondary-color">{{ $t('configuration.elementTitle.globalParameters') }}</span>
                        <small>{{ $t('configuration.elementSubtitle.globalParametersSubtitle') }}</small>
                      </div>
                    </b-col>
                    <b-col
                      v-if="canConfigureGlobalShipments"
                      sm="4"
                      md="4"
                      lg
                    >
                      <div
                        v-testing="'shipments'"
                        class="conf-card text-center d-flex flex-column py-3 mb-4"
                        @click="goToConfiguration('ConfigurationShipments')"
                      >
                        <div class="icon w-100 d-flex justify-content-center">
                          <exchange />
                        </div>
                        <span class="mt-2 secondary-color">{{ $t('configuration.elementTitle.elementsExchange') }}</span>
                        <small>{{ $t('configuration.elementSubtitle.elementsExchangeSubtitle') }}</small>
                      </div>
                    </b-col>
                    <div class="d-none d-lg-block d-xl-block w-100" />
                    <b-col
                      sm="4"
                      md="4"
                      lg
                    >
                      <div
                        qa="configuration-home-accounting"
                        class="conf-card text-center d-flex flex-column py-3 mb-4"
                        @click="goToConfiguration('ConfigurationAccounting')"
                      >
                        <div class="icon w-100 d-flex justify-content-center">
                          <accounting />
                        </div>
                        <span class="mt-2 secondary-color">{{ $t('configuration.elementTitle.billing') }}</span>
                        <small>{{ $t('configuration.elementSubtitle.billingSubtitle') }}</small>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </b-tab>
              <b-tab v-if="hasAnyLocalConfigurationOperation">
                <template #title>
                  <span v-testing="'laboratory-configuration-tab'">{{ `${$t('configuration.layout.localConfiguration')} ${laboratoryName}` }}</span>
                </template>
                <div class="mt-4 scroll-area">
                  <b-row>
                    <b-col
                      v-if="canConfigureLocalTemplate"
                      sm="4"
                      md="4"
                      lg
                    >
                      <div
                        v-testing="'templates'"
                        class="conf-card text-center d-flex flex-column py-3 mb-4"
                        @click="goToConfiguration('ConfigurationTemplates')"
                      >
                        <div class="icon w-100 d-flex justify-content-center">
                          <templates />
                        </div>
                        <span class="mt-2 secondary-color">{{ $t('configuration.elementTitle.templates') }}</span>
                        <small>{{ $t('configuration.elementSubtitle.templatesSubtitle') }}</small>
                      </div>
                    </b-col>
                    <b-col
                      sm="4"
                      md="4"
                      lg
                      class="d-none"
                    >
                      <div
                        v-testing="'people-management'"
                        class="conf-card text-center d-flex flex-column py-3 mb-4"
                      >
                        <div class="icon w-100 d-flex justify-content-center">
                          <users />
                        </div>
                        <span class="mt-2 secondary-color">{{ $t('configuration.elementTitle.peopleManagement') }}</span>
                        <small>{{ $t('configuration.elementSubtitle.peopleManagementSubtitle') }}</small>
                      </div>
                    </b-col>
                    <b-col
                      v-if="canConfigureLocalCases"
                      sm="4"
                      md="4"
                      lg
                    >
                      <div
                        v-testing="'laboratory-cases'"
                        class="conf-card text-center d-flex flex-column py-3 mb-4"
                        @click="goToConfiguration('ConfigurationLocalCases')"
                      >
                        <div class="icon w-100 d-flex justify-content-center">
                          <cases />
                        </div>
                        <span class="mt-2 secondary-color">{{ $t('configuration.elementTitle.cases') }}</span>
                        <small>{{ $t('configuration.elementSubtitle.localCasesSubtitle') }}</small>
                      </div>
                    </b-col>
                    <b-col
                      v-if="canConfigureLocalSamples"
                      sm="4"
                      md="4"
                      lg
                    >
                      <div
                        v-testing="'laboratory-samples'"
                        class="conf-card text-center d-flex flex-column py-3 mb-4"
                        @click="goToConfiguration('ConfigurationLocalSamples')"
                      >
                        <div class="icon w-100 d-flex justify-content-center">
                          <samples />
                        </div>
                        <span class="mt-2 secondary-color">{{ $t('configuration.elementTitle.samples') }}</span>
                        <small>{{ $t('configuration.elementSubtitle.samplesSubtitle') }}</small>
                      </div>
                    </b-col>
                    <!-- Oculto por el momento con "d-none" -->
                    <b-col
                      sm="4"
                      md="4"
                      lg
                      class="d-none"
                    >
                      <div
                        v-testing="'portions-subportions'"
                        class="conf-card text-center d-flex flex-column py-3 mb-4"
                      >
                        <div class="icon w-100 d-flex justify-content-center">
                          <portions-subportions />
                        </div>
                        <span class="mt-2 secondary-color">{{ $t('configuration.elementTitle.elements') }}</span>
                        <small>{{ $t('configuration.elementSubtitle.elementsSubtitle') }}</small>
                      </div>
                    </b-col>
                    <b-col
                      v-if="canConfigureLocalAssays"
                      sm="4"
                      md="4"
                      lg
                    >
                      <div
                        v-testing="'laboratory-assays'"
                        class="conf-card text-center d-flex flex-column py-3 mb-4"
                        @click="goToConfiguration('ConfigurationLocalAssays')"
                      >
                        <div class="icon w-100 d-flex justify-content-center">
                          <assays />
                        </div>
                        <span class="mt-2 secondary-color">{{ $t('configuration.elementTitle.assays') }}</span>
                        <small>{{ $t('configuration.elementSubtitle.localAssaysSubtitle') }}</small>
                      </div>
                    </b-col>
                    <b-col
                      v-if="canConfigureLocalNotifications"
                      sm="4"
                      md="4"
                      lg
                    >
                      <div
                        v-testing="'notifications-alarms'"
                        class="conf-card text-center d-flex flex-column py-3 mb-4"
                        @click="goToConfiguration('ConfigurationLocalNotifications')"
                      >
                        <div class="icon w-100 d-flex justify-content-center">
                          <notifications />
                        </div>
                        <span class="mt-2 secondary-color">{{ $t('configuration.elementTitle.notificationsAlarms') }}</span>
                        <small>{{ $t('configuration.elementSubtitle.notificationsAlarmsSubtitle') }}</small>
                      </div>
                    </b-col>
                    <div class="d-none d-lg-block d-xl-block w-100" />
                    <b-col
                      v-if="canConfigureLocalIncidents"
                      sm="4"
                      md="4"
                      lg
                    >
                      <div
                        v-testing="'laboratory-incidents'"
                        class="conf-card text-center d-flex flex-column py-3 mb-4"
                        @click="goToConfiguration('ConfigurationLocalIncidents')"
                      >
                        <div class="icon w-100 d-flex justify-content-center">
                          <incidents />
                        </div>
                        <span class="mt-2 secondary-color">{{ $t('configuration.elementTitle.incidents') }}</span>
                        <small>{{ $t('configuration.elementSubtitle.localIncidentsSubtitle') }}</small>
                      </div>
                    </b-col>
                    <b-col
                      v-if="canConfigureLocalAutomation"
                      sm="4"
                      md="4"
                      lg
                    >
                      <div
                        v-testing="'automation'"
                        class="conf-card text-center d-flex flex-column py-3 mb-4"
                        @click="goToConfiguration('ConfigurationAutomation')"
                      >
                        <div class="icon w-100 d-flex justify-content-center">
                          <automation />
                        </div>
                        <span class="mt-2 secondary-color">{{ $t('configuration.elementTitle.automation') }}</span>
                        <small>{{ $t('configuration.elementSubtitle.automationSubtitle') }}</small>
                      </div>
                    </b-col>
                    <!-- Oculto por el momento con "d-none" -->
                    <b-col
                      sm="4"
                      md="4"
                      lg
                      class="d-none"
                    >
                      <div
                        v-testing="'quality'"
                        class="conf-card text-center d-flex flex-column py-3 mb-4"
                      >
                        <div class="icon w-100 d-flex justify-content-center">
                          <quality />
                        </div>
                        <span class="mt-2 secondary-color">{{ $t('configuration.elementTitle.quality') }}</span>
                        <small>{{ $t('configuration.elementSubtitle.qualitySubtitle') }}</small>
                      </div>
                    </b-col>
                    <b-col
                      v-if="canConfigureLocalPrint"
                      sm="4"
                      md="4"
                      lg
                    >
                      <div
                        v-testing="'print'"
                        class="conf-card text-center d-flex flex-column py-3 mb-4"
                        @click="goToConfiguration('ConfigurationPrint')"
                      >
                        <div class="icon w-100 d-flex justify-content-center">
                          <print />
                        </div>
                        <span class="mt-2 secondary-color">{{ $t('configuration.elementTitle.print') }}</span>
                        <small>{{ $t('configuration.elementSubtitle.printSubtitle') }}</small>
                      </div>
                    </b-col>
                    <b-col
                      v-if="canConfigureLocalVitrolink"
                      sm="4"
                      md="4"
                      lg
                    >
                      <div
                        v-testing="'vitrolink'"
                        class="conf-card text-center d-flex flex-column py-3 mb-4"
                        @click="goToConfiguration('ConfigurationVitrolink')"
                      >
                        <div class="icon w-100 d-flex justify-content-center">
                          <connections />
                        </div>
                        <span class="mt-2 secondary-color">{{ $t('configuration.elementTitle.vitrolink') }}</span>
                        <small>{{ $t('configuration.elementSubtitle.vitrolinkSubtitle') }}</small>
                      </div>
                    </b-col>
                    <b-col
                      v-if="canConfigureLocalInfoLaboratory"
                      sm="4"
                      md="4"
                      lg
                    >
                      <div
                        v-testing="'laboratory'"
                        class="conf-card text-center d-flex flex-column py-3 mb-4"
                        @click="goToConfiguration('ConfigurationLaboratory')"
                      >
                        <div class="icon w-100 d-flex justify-content-center">
                          <health-center-setup />
                        </div>
                        <span class="mt-2 secondary-color">{{ $t('configuration.elementTitle.laboratory') }}</span>
                        <small>{{ $t('configuration.elementSubtitle.laboratorySubtitle') }}</small>
                      </div>
                    </b-col>
                    <div class="d-none d-lg-block d-xl-block w-100" />
                    <b-col
                      v-if="canConfigureLocalParamters"
                      sm="4"
                      md="4"
                      lg
                    >
                      <div
                        v-testing="'local-parameters'"
                        class="conf-card text-center d-flex flex-column py-3 mb-4"
                        @click="goToConfiguration('ConfigurationParametersLocal')"
                      >
                        <div class="icon w-100 d-flex justify-content-center">
                          <local-parameters />
                        </div>
                        <span class="mt-2 secondary-color">{{ $t('configuration.elementTitle.localParameters') }}</span>
                        <small>{{ $t('configuration.elementSubtitle.localParametersSubtitle') }}</small>
                      </div>
                    </b-col>
                    <b-col
                      v-if="showConfigurationInstrumentation"
                      sm="4"
                      md="4"
                      lg
                    >
                      <div
                        v-testing="'local-instrumentation'"
                        class="conf-card text-center d-flex flex-column py-3 mb-4"
                        @click="goToConfiguration('ConfigurationInstrumentation')"
                      >
                        <div class="icon w-100 d-flex justify-content-center">
                          <instrumentation />
                        </div>
                        <span class="mt-2 secondary-color">{{ $t('configuration.elementTitle.instrumentation') }}</span>
                        <small>{{ $t('configuration.elementSubtitle.instrumentationSubtitle') }}</small>
                      </div>
                    </b-col>
                    <b-col
                      sm="4"
                      md="4"
                      lg
                    >
                      <div
                        v-testing="'accounting'"
                        class="conf-card text-center d-flex flex-column py-3 mb-4"
                        @click="goToConfiguration('ConfigurationLocalAccounting')"
                      >
                        <div class="icon w-100 d-flex justify-content-center">
                          <accounting />
                        </div>
                        <span class="mt-2 secondary-color">{{ $t('configuration.elementTitle.billing') }}</span>
                        <small>{{ $t('configuration.elementSubtitle.billingSubtitle') }}</small>
                      </div>
                    </b-col>
                    <!-- TODO: Mock, pending back implementation -->
                    <!--                    <b-col-->
                    <!--                      sm="4"-->
                    <!--                      md="4"-->
                    <!--                      lg-->
                    <!--                    >-->
                    <!--                      <div-->
                    <!--                        v-testing="'archive'"-->
                    <!--                        class="conf-card text-center d-flex flex-column py-3 mb-4"-->
                    <!--                        @click="goToConfiguration('ConfigurationLocalArchive')"-->
                    <!--                      >-->
                    <!--                        <div class="icon w-100 d-flex justify-content-center">-->
                    <!--                          <archive />-->
                    <!--                        </div>-->
                    <!--                        <span class="mt-2 secondary-color">{{ $t('configuration.elementTitle.archiveManagement') }}</span>-->
                    <!--                        <small>{{ $t('configuration.sections.archiveLevels') }}</small>-->
                    <!--                      </div>-->
                    <!--                    </b-col>-->
                    <b-col
                      v-if="showLaboratoryModule"
                      sm="4"
                      md="4"
                      lg
                    >
                      <div
                        v-testing="'archive'"
                        class="conf-card text-center d-flex flex-column py-3 mb-4"
                        @click="goToConfiguration('ConfigurationLaboratoryModule')"
                      >
                        <div class="icon w-100 d-flex justify-content-center">
                          <laboratory />
                        </div>
                        <span class="mt-2 secondary-color">{{ $t('configuration.elementTitle.laboratoryModule') }}</span>
                        <small>{{ $t('configuration.elementSubtitle.laboratoryModule') }}</small>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { StoreUtils } from '@/shared/util/store-utils'
import {
    MODULE_OPERATION_GLOBAL_CONFIGURATION_PREFIX,
    MODULE_OPERATION_LOCAL_CONFIGURATION_PREFIX,
    ModuleOperation
} from '@/api/operations/models/module-operation'

// Icons
import HealthCenter from '@/assets/images/svg/HealthCenter'
import HealthCenterSetup from '@/assets/images/svg/HealthCenterSetup'
import Demography from '@/assets/images/svg/Demography'
import Cases from '@/assets/images/svg/Cases'
import Samples from '@/assets/images/svg/Samples'
import PortionsSubportions from '@/assets/images/svg/PortionsSubportions'
import Assays from '@/assets/images/svg/Assays'
import Incidents from '@/assets/images/svg/Incidents'
import Users from '@/assets/images/svg/Users'
import Notifications from '@/assets/images/svg/Notifications'
import Exchange from '@/assets/images/svg/Exchange'
import Accounting from '@/assets/images/svg/Accounting'
import Automation from '@/assets/images/svg/Automation'
import Print from '@/assets/images/svg/Print'
import Connections from '@/assets/images/svg/Connections'
import LocalParameters from '@/assets/images/svg/LocalParameters'
import Templates from '@/assets/images/svg/Templates'
import Quality from '@/assets/images/svg/Quality'
import Instrumentation from '@/assets/images/svg/Instrumentation'
import Laboratory from '@/assets/images/svg/Laboratory'

export default {
    name: 'ConfigurationHome',
    components: {
        HealthCenter,
        HealthCenterSetup,
        Demography,
        Cases,
        Samples,
        PortionsSubportions,
        Assays,
        Incidents,
        Users,
        Notifications,
        Exchange,
        Accounting,
        Automation,
        Print,
        Connections,
        LocalParameters,
        Templates,
        Quality,
        Instrumentation,
        Laboratory
    },
    data() {
        return {
            tabIndex: this.$store.getters['configuration/tabIndex']
        }
    },
    computed: {
        laboratoryName() {
            return StoreUtils.selectedLaboratoryConfiguration?.laboratory.labName
        },
        hasAnyGlobalConfigurationOperation() {
            return this.hasGlobalOperationStartingWith(MODULE_OPERATION_GLOBAL_CONFIGURATION_PREFIX)
        },
        hasAnyLocalConfigurationOperation() {
            return this.hasLocalOperationStartingWith(MODULE_OPERATION_LOCAL_CONFIGURATION_PREFIX)
        },
        canConfigureGlobalRequesterStructure() {
            return this.hasOperationInAnyLaboratoryGlobalMixin(ModuleOperation.CONFIGURATION_GLOBAL_REQUESTER_STRUCTURE)
        },
        canConfigureGlobalDemography() {
            return this.hasOperationInAnyLaboratoryGlobalMixin(ModuleOperation.CONFIGURATION_GLOBAL_DEMOGRAPHY)
        },
        canConfigureGlobalPersons() {
            return this.hasOperationInAnyLaboratoryGlobalMixin(ModuleOperation.CONFIGURATION_GLOBAL_PERSONS)
        },
        canConfigureGlobalCases() {
            return this.hasOperationInAnyLaboratoryGlobalMixin(ModuleOperation.CONFIGURATION_GLOBAL_CASES)
        },
        canConfigureGlobalSamples() {
            return this.hasOperationInAnyLaboratoryGlobalMixin(ModuleOperation.CONFIGURATION_GLOBAL_SAMPLES)
        },
        canConfigureGlobalAssays() {
            return this.hasOperationInAnyLaboratoryGlobalMixin(ModuleOperation.CONFIGURATION_GLOBAL_ASSAYS)
        },
        canConfigureGlobalNotifications() {
            return this.hasOperationInAnyLaboratoryGlobalMixin(ModuleOperation.CONFIGURATION_GLOBAL_NOTIFICATIONS)
        },
        canConfigureGlobalIncidents() {
            return this.hasOperationInAnyLaboratoryGlobalMixin(ModuleOperation.CONFIGURATION_GLOBAL_INCIDENTS)
        },
        canConfigureGlobalParameters() {
            return this.hasOperationInAnyLaboratoryGlobalMixin(ModuleOperation.CONFIGURATION_GLOBAL_PARAMETERS)
        },
        canConfigureGlobalShipments() {
            return this.hasOperationInAnyLaboratoryGlobalMixin(ModuleOperation.CONFIGURATION_GLOBAL_SHIPMENTS)
        },
        canConfigureLocalTemplate() {
            return this.hasOperationInCurrentLaboratoryGlobalMixin(ModuleOperation.CONFIGURATION_LOCAL_TEMPLATE)
        },
        canConfigureLocalCases() {
            return this.hasOperationInCurrentLaboratoryGlobalMixin(ModuleOperation.CONFIGURATION_LOCAL_CASES)
        },
        canConfigureLocalSamples() {
            return this.hasOperationInCurrentLaboratoryGlobalMixin(ModuleOperation.CONFIGURATION_LOCAL_SAMPLES)
        },
        canConfigureLocalAssays() {
            return this.hasOperationInCurrentLaboratoryGlobalMixin(ModuleOperation.CONFIGURATION_LOCAL_ASSAYS)
        },
        canConfigureLocalNotifications() {
            return this.hasOperationInCurrentLaboratoryGlobalMixin(ModuleOperation.CONFIGURATION_LOCAL_NOTICE_NOTIFICATION_ALARMS)
        },
        canConfigureLocalIncidents() {
            return this.hasOperationInCurrentLaboratoryGlobalMixin(ModuleOperation.CONFIGURATION_LOCAL_INCIDENTS)
        },
        canConfigureLocalShipments() {
            return this.hasOperationInCurrentLaboratoryGlobalMixin(ModuleOperation.CONFIGURATION_LOCAL_SHIPMENTS)
        },
        canConfigureLocalAutomation() {
            return this.hasOperationInCurrentLaboratoryGlobalMixin(ModuleOperation.CONFIGURATION_LOCAL_AUTOMATION)
        },
        canConfigureLocalPrint() {
            return this.hasOperationInCurrentLaboratoryGlobalMixin(ModuleOperation.CONFIGURATION_LOCAL_PRINT)
        },
        canConfigureLocalVitrolink() {
            return this.hasOperationInCurrentLaboratoryGlobalMixin(ModuleOperation.CONFIGURATION_LOCAL_VITROLINK)
        },
        canConfigureLocalInfoLaboratory() {
            return this.hasOperationInCurrentLaboratoryGlobalMixin(ModuleOperation.CONFIGURATION_LOCAL_INFO_LABORATORY)
        },
        canConfigureLocalParamters() {
            return this.hasOperationInCurrentLaboratoryGlobalMixin(ModuleOperation.CONFIGURATION_LOCAL_PARAMETERS)
        },
        showLaboratoryModule() {
            return this.hasOperationInCurrentLaboratoryGlobalMixin(ModuleOperation.CONFIGURATION_LOCAL_LABORATORY_PROCESSES)
        },
        showConfigurationInstrumentation() {
            return this.hasOperationInCurrentLaboratoryGlobalMixin(ModuleOperation.CONFIGURATION_LOCAL_INSTRUMENT)
        }
    },
    methods: {
        goToConfiguration(section) {
            this.$router.push({ name: section })
        },
        updateTabSelection() {
            this.$store.commit('configuration/updateTabIndex', this.tabIndex)
        }
    }
}
</script>

<style lang="scss">

.configuration-home {
    height: calc(100vh - 100px);
}

.configuration-home .scroll-area {
    height: calc(100vh - 250px);
    overflow-y: auto;
    overflow-x: hidden;
    padding: 0 10px;
    position: relative;
}

.configuration-home .conf-card svg {
    width: 60px;
    transition: .2s;
}

.configuration-home .conf-card:hover {
    cursor: pointer;
    border: 1px solid vt-color(primary);
    box-shadow: 0 1px 5px 1px #c0c0c0;
    background: #FFF;
}

.configuration-home .conf-card .icon {
    height: 60px;
}

.configuration-home .conf-card:hover svg {
    width: 66px;
}

.configuration-home .main-title {
    font-size: font-size(very-big);
}

.configuration-home .vt-tabs .nav-tabs .nav-link, .vt-tabs--small .nav-tabs .nav-link {
    font-size: font-size(small);
    letter-spacing: 1px;
}

.configuration-home .vt-tabs .nav-tabs .nav-link.active, .vt-tabs--small .nav-tabs .nav-link.active:before {
    border-bottom: 3px solid #4680ff !important;
    border-left: 0;
    border-right: 0;
}

.configuration-home .vt-tabs .nav-tabs .nav-link, .vt-tabs--small .nav-tabs .nav-link {
    border-bottom: 3px solid transparent !important;
    border-left: 0;
    border-right: 0;
    padding: .5rem 1.5rem;
}

.configuration-home .conf-card {
    border: 1px solid vt-color(card-border);
    transition: .2s;
}

.configuration-home .conf-card small {
    color: vt-color(base-text);
}

@media (min-width: 1024px) {
    .configuration-home .col-lg {
        max-width: 20%;
    }
}

</style>
